import { useParams } from "react-router-dom";
import { isTaskTakeDebt } from "tm-shared/utils";

import { usePointSelector, useTaskSelector } from "@/hooks/redux";
import NotFound from "@/pages/System/NotFound";

import { TakeDebtPage } from "./TakeDebtPage";

const TakeDebt = () => {
    const { pointId = "", taskId = "" } = useParams();

    const currentTask = useTaskSelector(pointId, taskId);
    const currentPoint = usePointSelector(pointId);

    if (!currentTask || !isTaskTakeDebt(currentTask) || !currentPoint)
        return <NotFound />;

    return <TakeDebtPage point={currentPoint} task={currentTask} />;
};

export default TakeDebt;
